import PropTypes from "prop-types";

import StraightLineTool, {
  straightLinePropTypes,
  straightLineBaseDefaults,
} from "./StraightLineTool";
import EachSegment from "./wrapper/EachSegment";

// Config sobre StraightLineTool (auditoria 2026-07-17, item 1b). Ganha o
// backfill/fallback de `type` da base (antes passava each.type cru — validação
// Fable §2.3).
class Segment extends StraightLineTool {}

Segment.collectionKey = "segments";
Segment.EachComponent = EachSegment;
Segment.evoId = "interactive-segment";

Segment.propTypes = {
  ...straightLinePropTypes,
  type: PropTypes.oneOf(["LINE"]),
  segments: PropTypes.array.isRequired,
};

Segment.defaultProps = {
  ...straightLineBaseDefaults,
  type: "LINE",
  segments: [],
};

export default Segment;
